import {
  Box,
  Flex,
  HStack,
  Stack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@chakra-ui/react';
import { HelivanText } from '../helivan/HelivanText';
import { HelivanColor } from '../helivan/HelivanColor';
import { OrganizationSettings } from './OrganizationSettings';
import { AgentSettings } from './AgentSettings';
import { UsageLimits } from './UsageLimits';
import { DangerZone } from './DangerZone';

export const Settings = () => {
  return (
    <Stack width="full" height="full" spacing={0} overflow="hidden">
      {/* Header */}
      <Flex
        width="full"
        alignItems="center"
        py="12px"
        px="24px"
        bg={HelivanColor.background.primary}
        borderBottom="1px solid"
        borderBottomColor={HelivanColor.border.primary}
        justifyContent="space-between"
        gap={4}
        flexShrink={0}
      >
        <HStack spacing={6}>
          <HelivanText variant="sectionHeader">Settings</HelivanText>
        </HStack>
      </Flex>

      {/* Content */}
      <Flex
        flex="1"
        overflowY="auto"
        bg={HelivanColor.background.secondary}
        p={6}
      >
        <Box
          width="full"
          maxWidth="1200px"
          mx="auto"
          bg={HelivanColor.background.primary}
          borderRadius="12px"
          border="1px solid"
          borderColor={HelivanColor.border.primary}
          display="flex"
          flexDirection="column"
          maxHeight="100%"
        >
          <Tabs variant="line" colorScheme="blue" display="flex" flexDirection="column" flex="1" overflow="hidden">
            <TabList
              bg={HelivanColor.background.lightestGrey}
              px={4}
              borderBottom="1px solid"
              borderBottomColor={HelivanColor.border.primary}
              flexShrink={0}
            >
              <Tab
                py={3}
                fontSize="14px"
                fontWeight={500}
                color={HelivanColor.text.blueMid}
                _selected={{
                  color: HelivanColor.text.helivanBlue,
                  borderBottomColor: HelivanColor.text.helivanBlue,
                  fontWeight: 600,
                }}
              >
                Organization
              </Tab>
              <Tab
                py={3}
                fontSize="14px"
                fontWeight={500}
                color={HelivanColor.text.blueMid}
                _selected={{
                  color: HelivanColor.text.helivanBlue,
                  borderBottomColor: HelivanColor.text.helivanBlue,
                  fontWeight: 600,
                }}
              >
                Agent Settings
              </Tab>
              <Tab
                py={3}
                fontSize="14px"
                fontWeight={500}
                color={HelivanColor.text.blueMid}
                _selected={{
                  color: HelivanColor.text.helivanBlue,
                  borderBottomColor: HelivanColor.text.helivanBlue,
                  fontWeight: 600,
                }}
              >
                Usage & Limits
              </Tab>
              <Tab
                py={3}
                fontSize="14px"
                fontWeight={500}
                color={HelivanColor.text.blueMid}
                _selected={{
                  color: HelivanColor.text.helivanBlue,
                  borderBottomColor: HelivanColor.text.helivanBlue,
                  fontWeight: 600,
                }}
              >
                Account
              </Tab>
            </TabList>

            <TabPanels flex="1" overflowY="auto">
              <TabPanel p={4}>
                <OrganizationSettings />
              </TabPanel>
              <TabPanel p={6}>
                <AgentSettings />
              </TabPanel>
              <TabPanel p={6}>
                <UsageLimits />
              </TabPanel>
              <TabPanel p={6}>
                <DangerZone />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Box>
      </Flex>
    </Stack>
  );
};
